import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from 'router';
import Data from 'Contexts/DataContext';
import ThemeContextWrapper from 'Contexts/ThemeContext';
import { Box } from '@mui/material';
import { SearchProvider } from './Contexts/SearchContext';

function App() {
    return (
        <ThemeContextWrapper>
            <SearchProvider>
                <Box className="App">
                    <Data>
                        <RouterProvider router={router} />
                    </Data>
                </Box>
            </SearchProvider>
        </ThemeContextWrapper>
    );
}

export default App;
